import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditWhyChooseUsItem from "../../components/why-choose-us/FormAddEditWhyChooseUsItem";
import { useGetWhyChooseUsItem } from "../../hooks/why-choose-us/useGetWhyChooseUsItem";
import LoadingPage from "../../components/global/LoadingPage";

const EditWhyChooseUsItem = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, item } = useGetWhyChooseUsItem(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/why-choose-us");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditWhyChooseUsItem
                isEdit={true}
                currentData={item}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditWhyChooseUsItem;
